/** @jsx isolateComponent */
import { Fragment } from 'react';

import { isolateComponent } from '@zapier/style-encapsulation';
import { Heading, HeadingLevel, Typography } from '@zapier/design-system';

import DocLinks from '../../shared/DocLinks';

type App = {
  id: string;
  name: string;
  slug: string;
};

type AppDocsProps = {
  /** Apps to link docs for */
  apps: App[];
};

const Styles = {
  rebrandTitle: {
    ...Typography.Body4,
  },
};

/** Renders the list of general docs in `<DocsStep>`. */
const AppDocs = ({ apps }: AppDocsProps) => {
  /** Prevent duplicate app docs from being shown by checking
   *  that each app id only appears once. Maintains order of
   *  apps as used in the selected Zap.
   */
  const uniqueApps = apps.reduce<App[]>((acc, app) => {
    const uniqueAppIds = acc.map(accApp => accApp.id);
    if (!uniqueAppIds.includes(app.id)) acc.push(app);
    return acc;
  }, []);
  const DOC_LINKS = uniqueApps.map(app => ({
    title: `${app.name} help`,
    href: `/apps/${app.slug}/help`,
    appId: app.id,
  }));

  return (
    <Fragment>
      <Heading css={Styles.rebrandTitle}>Related</Heading>
      <HeadingLevel>
        <DocLinks links={DOC_LINKS} />
      </HeadingLevel>
    </Fragment>
  );
};

export default AppDocs;
